
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact/[prefix]",
      function () {
        return require("private-next-pages/contact/[prefix].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contact/[prefix]"])
      });
    }
  